import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useThirdPartyLoanStore } from '../../hooks/useThirdPartyLoanStore';
import { SearchExistingEntityCard } from './searchExistingEntityCard';
import { OneToolCardBorder } from './oneToolCard';
import { BorrowerInformationAccordionSummary } from '../common/borrowerInformationAccordion';
import { useQuoteTypeStore } from '../../hooks/useQuoteTypeStore';

export const SearchExistingEntity = observer(() => {
  const { quoteTypeStore } = useQuoteTypeStore();
  const borrowerFormStores = quoteTypeStore.borrowersStore.borrowerFormStores.filter(
    borrowerFormStore => !!borrowerFormStore.form.fields.firstName.value
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchExistingEntityCard />
      </Grid>
      {borrowerFormStores.map(borrowerFormStore => (
        <Grid item xs={12}>
          <OneToolCardBorder>
            <BorrowerInformationAccordionSummary
              borrowerFormStore={borrowerFormStore}
            />
          </OneToolCardBorder>
        </Grid>
      ))}
    </Grid>
  );
});
